<template>
  <v-container class="px-0 pt-0 pb-5">
    <div class="text-right px-4 pt-3" @click="goBack">
      <Icon color="primaryColor" icon="cross-icon" />
    </div>

    <section class="px-10">
      <v-card class="mb-6 pa-4">
        <v-form @submit.prevent="onSubmit">
          <v-row>
            <v-col cols="12">
              <v-text-field
                ref="titleField"
                v-model="formState.title"
                :error-messages="errors?.title"
                variant="outlined"
                :rules="[(value) => !!value || 'Required']"
              >
                <template #label>
                  Document Title <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formState.description"
                :error-messages="errors?.description"
                label="Description"
                variant="outlined"
                rows="3"
              />
            </v-col>

            <v-col cols="12">
              <v-file-input
                ref="fileField"
                v-model="formState.file"
                :error-messages="errors?.file"
                variant="outlined"
                accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
                show-size
                :rules="[(value) => !!value || 'Required']"
              >
                <template #label>
                  Select Document <span style="color: red">*</span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </section>
  </v-container>

  <section>
    <ButtonFixed
      :custom-class="[
        'text-white',
        {
          'primary-button': !disableSave,
          'grey-disable': disableSave || loading,
        },
      ]"
      custom-icon-class="add-new-circle-icon"
      text="Upload"
      @click="onSubmit"
    />
  </section>
</template>

<script lang="ts" setup>
import Icon from "@/components/Icons/Icon.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { filesService } from "@/api/services/file";

const router = useRouter();
const route = useRoute();
const errors = ref(null);
const loading = ref(false);
const titleField = ref(null);
const fileField = ref(null);

const formState = ref({
  title: "",
  description: "",
  file: null as File | null,
});

const disableSave = computed(() => {
  return !formState.value.title || !formState.value.file;
});

const onSubmit = async () => {
  if (loading.value || disableSave.value) return;

  loading.value = true;
  const formData = new FormData();
  formData.append("title", formState.value.title);
  formData.append("description", formState.value.description);
  if (formState.value.file) {
    formData.append("file", formState.value.file);
  }

  try {
    await filesService.store(formData);
    router.replace({ name: "document-documents" });
  } catch (error: any) {
    errors.value = error.response?.data?.errors;
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  return route.params.page === "files-activity"
    ? router.push({ name: "documents" })
    : router.push({ name: "document-documents" });
};

onMounted(() => {
  // Validate field manually on mount
  titleField.value?.validate();
  fileField.value?.validate();
});
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 8px;
  border: 1px solid #e0e4e9;
  box-shadow: none;
}
</style>
